import { datadogRum } from '@datadog/browser-rum';
import { getDeliveryOrPickupByVehicle } from '@/SearchResults/ResultTile/hooks';
import { Vehicle } from '~/contracts';
import replaceUndefinedWithNull from '~/utilities/replaceUndefinedWithNull';

export function getVehicleData(latestVehicles: Partial<Vehicle>[]) {
  return latestVehicles.map((v: Partial<Vehicle>, tileIndex) => {
    const {
      apr,
      discounts,
      downPaymentDetails,
      estimatedTaxesAndFees,
      monthlyPayment,
      pricingErrorMessage,
      term,
      total
    } = v.price ?? {};
    const downPayment = v.price?.downPaymentDetails?.totalCashDue;

    const {
      deliveryInfo,
      isPurchasePending,
      locationId,
      pickupInfo,
      stockNumber,
      transportCost,
      vehicleId,
      vehicleInventoryType,
      vehicleLockType,
      vehiclePurchaseType,
      vehicleUnlockDateTime
    } = v;
    const hasTerms = downPayment != null && monthlyPayment != null;

    const { activityType, dateAvailable, getItBy, routeId } =
      getDeliveryOrPickupByVehicle(v);

    if (
      (deliveryInfo?.activityType || pickupInfo?.activityType) &&
      !activityType
    ) {
      datadogRum.addAction(
        'null-tile-info-activityType-with-valid-delivery-or-pickup',
        {
          deliveryInfo,
          pickupInfo,
          tileInfoActivityType: activityType
        }
      );
    }

    return replaceUndefinedWithNull({
      deliveryInfo,
      isPurchasePending,
      locationId,
      pickupInfo,
      stockNumber,
      tileIndex,
      tileInfo: {
        activityType,
        apr,
        discounts,
        downPayment,
        estimatedTaxesAndFees,
        getItBy,
        getItByDateIso: dateAvailable,
        hasTerms,
        monthlyPayment,
        nonRefundableShippingFees:
          downPaymentDetails?.nonRefundableShippingFees,
        pricingErrorMessage,
        routeId,
        shippingCost: transportCost,
        stickerPrice: total,
        term
      },
      vehicleId,
      vehicleInventoryType,
      vehicleLockType,
      vehiclePurchaseType,
      vehicleUnlockDateTime
    });
  });
}
